import { Link } from 'react-router-dom';
import { Button, Card, Badge } from '@kss/ui';

export default function Landing() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-16">
      <div className="text-center">
        <Badge variant="success" className="mb-4">Launch offer</Badge>
        <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl">
          Launch your next SaaS admin in a weekend
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-[var(--color-text-secondary)]">
          KSS gives you a production-grade monorepo with auth, theming, a dashboard and 56+ components — ready to extend.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/login"><Button size="lg">Get started</Button></Link>
          <Link to="/contact"><Button size="lg" variant="outline">Talk to us</Button></Link>
        </div>
      </div>

      <div className="mt-16 grid gap-4 md:grid-cols-3">
        {[
          { title: 'Starter', price: '₹0', desc: 'All the primitives, community support.' },
          { title: 'Pro', price: '₹2,999', desc: 'Panel + DataGrid + Spreadsheet, updates for 1 year.' },
          { title: 'Team', price: '₹9,999', desc: 'Everything, priority support, custom theme.' },
        ].map((p) => (
          <Card key={p.title} title={p.title} subtitle={p.price}>
            <p className="text-sm text-[var(--color-text-secondary)]">{p.desc}</p>
            <div className="mt-4">
              <Button fullWidth>Choose {p.title}</Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
